import styled from 'styled-components';
import _Magnifier from '../../atoms/icons/Magnifier';
export const Container = styled.div `
    border-radius: 6px;
    background-color: white;
    box-shadow: 0 0 10px rgba(26, 26, 26, 0.11);
    border: 1px solid #f5f5f7;
    overflow-x: auto;

    > table {
        width: 100%;

        > thead,
        > tbody {
            > tr {
                > th,
                > td {
                    padding: 0.75rem;
                    color: ${props => props.theme.primary.base};

                    &:last-of-type {
                        > button {
                            appearance: none;
                            background: none;
                            border: none;
                            color: inherit;
                            cursor: pointer;

                            > svg {
                                display: block;
                                fill: currentColor;
                            }
                        }
                    }
                }
            }
        }

        > thead {
            > tr {
                > th {
                    font-weight: 600;
                }
            }
        }

        > tbody {
            > tr {
                cursor: ${props => (props.isClickable ? 'pointer' : 'initial')};

                > td {
                    &.noWrap,
                    &.truncate {
                        white-space: nowrap;
                    }

                    &.truncate {
                        max-width: 100px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .react-loading-skeleton {
                        margin: 0;
                    }
                }

                &:nth-child(odd) {
                    > td {
                        background-color: #f5f5f7;
                    }
                }

                &:hover {
                    > td {
                        background-color: #e9eaee;
                    }
                }
            }
        }
    }
`;
export const MessageContainer = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 0;
    gap: 15px;
`;
export const Magnifier = styled(_Magnifier) `
    fill: #c7c7c7;
    width: 42px;
    height: 42px;
`;
export const Message = styled.div `
    display: block;
    font-size: 18px;
    color: #5d5d5d;
    text-align: center;
`;
